module.exports = __webpack_public_path__ + "img/center008.c1efcd1e.jpg";